import { SET_GCLID_SOURCE_TYPE } from 'actions';

export const setGclidSourceType = (gclid: string) => {
  return { gclid, type: SET_GCLID_SOURCE_TYPE };
};
